import api from '@/api'

export default {
    getPersonalInfo: (): Promise<kyobobook.PersonalInfo> => {
        return api.get({
            url: '/KyoboBook/PersonalInfo/api/get'
        })
    },

    setPersonalInfo(info: kyobobook.PersonalInfo): Promise<number> {
        return api.post({
            url: '/KyoboBook/PersonalInfo/api/set',
            data: info
        })
    }
}